import { render, staticRenderFns } from "./FilterAmount.vue?vue&type=template&id=2a4e604e&"
import script from "./FilterAmount.vue?vue&type=script&lang=ts&"
export * from "./FilterAmount.vue?vue&type=script&lang=ts&"
import style0 from "./FilterAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports